import { forwardRef } from 'react';
import { HeaderMCosmetic } from './HeaderMCosmetic';
import type { HeaderVariant, RootHeaderProps } from './types';

export type HeaderProps = Omit<RootHeaderProps, 'variant'>;

const HeaderVariants: Record<
  HeaderVariant,
  React.ForwardRefExoticComponent<
    Omit<HeaderProps, 'ref'> & React.RefAttributes<HTMLDivElement>
  >
> = {
  MCosmetic: HeaderMCosmetic,
};

export const Header = forwardRef<HTMLDivElement, RootHeaderProps>(
  ({ variant, children, ...props }, ref) => {
    const HeaderComp = HeaderVariants[variant];

    return (
      <HeaderComp {...props} ref={ref}>
        {children}
      </HeaderComp>
    );
  },
);
